import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import Rastreamento from '~/pages/Rastreamento';

function Routes() {
    return (
        <Switch>
            <Route path="/" exact component={Rastreamento} />
        </Switch>
    );
}

export default Routes;
